module.exports = __webpack_public_path__ + "img/jg2.4c8db7a8.png";